import { useState, useEffect, useContext } from "react";
import { Input, Spin, message } from "antd";
import { useParams } from "react-router-dom";
import MapContainerComponent from "../../../Components/MapContainer";
import profile from "../../../Assets/Icons/risk-profile-icon.svg";
import customerLogo from "../../../Assets/Icons/customer manage.svg";
import icon from "../../../Assets/Icons/allonge-security.svg";
import "./style.css";
import { getNotificationById } from "../../../API/User/notification";
import { UserContext } from "../../../App"

const ViewNotificationDetails = () => {
  const { id } = useParams();

  const { unreadNotificationCount, setUnreadNotificationCount } = useContext(UserContext)
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchNotification = async () => {
    try {
      setLoading(true);

      const res = await getNotificationById(id);

      if (Math.floor(res?.status / 100) === 2) {
        setData(res?.data?.data?.notification);
        setUnreadNotificationCount(res?.data?.data?.unread_notification_count)

      } else {
        messageApi.error("Failed to fetch notification");
      }
    } catch (err) {
      messageApi.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchNotification();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!data) return null;

  const meta = data.meta_data;

  return (
    <div className="notification-form">
      {contextHolder}

      <div className="view-notification">
        <div className="heading">Notification Detail</div>

        {/* VEHICLE INFO */}
        <div className="profile-details">
          <div className="image">
            <img
              src={
                data.customer_profile_picture ?
                  `${process.env.REACT_APP_MEDIA_URL}${data.customer_profile_picture}`
                  :
                  { customerLogo }
              } alt="Profile" className="profile-image" />
          </div>
          <div className="info">
            <div className="name">{data?.vehicle?.vehicle_name || ""}</div>
            <div className="email">{data?.vehicle?.driver_name || ""}</div>
          </div>
        </div>

        <hr className="divider" />

        {/* DETAILS */}
        <div className="form-items">
          <div className="input-group">
            <div className="title">Vehicle</div>
            <Input value={data?.vehicle?.vehicle_name || ""} disabled />
          </div>

          <div className="input-group">
            <div className="title">Location</div>
            <Input
              value={`${meta?.latitude || ""}, ${meta?.longitude || ""}`}
              disabled
            />
          </div>

          <div className="input-group">
            <div className="title">Status</div>
            <Input value={data.is_read ? "Read" : "Unread"} disabled />
          </div>

          <div className="input-group">
            <div className="title">Risk Score</div>
            <Input value={meta?.total_score || ""} disabled />
          </div>

          <div className="input-group">
            <div className="title">Reason</div>
            <Input value={data?.subtitle || ""} disabled />
          </div>
        </div>
      </div>

      {/* MAP */}
      <div className="map-wrapper">
        <div className="heat-map">
          {meta.latitude && meta.longitude ? <MapContainerComponent
            latitude={meta.latitude}
            longitude={meta.longitude}
            vehicle_name={data.vehicle.vehicle_name}
          /> :
            <div>
              No Corrdinates To Show Location on Map
            </div>
          }
        </div>
      </div>

      {/* FACTORS TABLE */}
      <div className="factors-table">
        <div className="table-header">
          <span className="header-factor">Factors</span>
          <span className="header-points">Points</span>
        </div>

        {Object.entries(meta)
          .filter(
            ([key]) =>
              key !== "total_score" &&
              key !== "latitude" &&
              key !== "longitude" &&
              key !== "retained_until"
          )
          .map(([key, value], index) => (
            <div className="table-row" key={index}>
              <span className="factor">
                {key
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>
              <span className="points">{value}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ViewNotificationDetails;
